export interface Starter {
	id: number;
	name: string;
	translationKey: string;
	imagePath: string;
	stats: {
		walk: number;
		trot: number;
		canter: number;
		agility: number;
		balance: number;
		speed: number;
		jumping: number;
		stamina: number;
	};
	disciplines: {
		showJumping: number;
		crossCountry: number;
		dressage: number;
		western: number;
		driving: number;
		racing: number;
	};
	starterGenes: Gene;
	mustHaveGenes: Gene;
}

export interface Gene {
	black: {
		dun: {
			cream: {
				value: boolean;
			};
			value: boolean;
		};
		cream: {
			value: boolean;
		};
		value: boolean;
	};
	bay: {
		dun: {
			cream: {
				value: boolean;
			};
			value: boolean;
		};
		cream: {
			value: boolean;
		};
		value: boolean;
	};
	chestnut: {
		dun: {
			cream: {
				value: boolean;
			};
			value: boolean;
		};
		cream: {
			value: boolean;
		};
		value: boolean;
	};
	grey: boolean;
	tobiano: boolean;
	overo: boolean;
	leopard: boolean;
	marks: {
		head: boolean;
		leg: boolean;
	};
	[key: string]: any;
}
export const generateDefaultGene = () => ({
	black: {
		dun: {
			cream: {
				value: false,
			},
			value: false,
		},
		cream: {
			value: false,
		},
		value: false,
	},
	bay: {
		dun: {
			cream: {
				value: false,
			},
			value: false,
		},
		cream: {
			value: false,
		},
		value: false,
	},
	chestnut: {
		dun: {
			cream: {
				value: false,
			},
			value: false,
		},
		cream: {
			value: false,
		},
		value: false,
	},
	grey: false,
	tobiano: false,
	overo: false,
	leopard: false,
	marks: {
		head: false,
		leg: false,
	},
});

export const defaultStarter: Starter = {
	id: 1,
	name: '',
	translationKey: '',
	imagePath: '',
	stats: {
		walk: 0,
		trot: 0,
		canter: 0,
		agility: 0,
		balance: 0,
		speed: 0,
		jumping: 0,
		stamina: 0,
	},
	disciplines: {
		showJumping: 0,
		crossCountry: 0,
		dressage: 0,
		western: 0,
		racing: 0,
		driving: 0,
	},
	starterGenes: generateDefaultGene(),
	mustHaveGenes: generateDefaultGene(),
};
